module.exports = __webpack_public_path__ + "static/media/ic-compliance-monitor.c4ac7505.svg";